{
  "title": "How to Publish an Announcement and Email It",
  "description": "Create a competition announcement and choose whether to also email students, teachers or judges; covers preview, test email, recipient scope and the send limit.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, the announcement shows on the competition page and is emailed to the recipients you chose.",
  "roleNote": "Organizer",
  "prerequisites": [
    "You have the competition permission to manage announcements",
    "To send email, the competition settings have a contact email filled in"
  ],
  "pathLabel": "Competition management → Operations → Announcements",
  "steps": [
    {
      "title": "1. Write the announcement",
      "description": "On the Announcements page add an announcement with a title and content (plain text; line breaks are kept and URLs become links automatically). \"Visible to (website)\" can be everyone (including visitors), participants or judges, and only decides who sees it on the website. Pressing \"Publish announcement\" alone sends no email; website announcements and email are separate."
    },
    {
      "title": "2. Preview and send a test email",
      "description": "Press \"Preview\" to see the announcement; \"Send a test email to me\" sends only to you, marked as a test, without creating the announcement or emailing anyone else. Send a test email the first time."
    },
    {
      "title": "3. Choose whether to email, and who",
      "description": "Tick \"Also send an email notification\" and choose the roles (students, teachers, judges); you can narrow students and teachers further by category, round and registration field (for example Group). These filters do not affect judges. The page shows \"Will send to: N recipients\" live, and you cannot send when it is 0. Each send is limited to 300 recipients; narrow the filters and send in batches when you exceed it."
    },
    {
      "title": "4. Confirm and send",
      "description": "\"Publish and send email\" opens a confirmation dialog with the count and the exact subject and body that will be sent; Cancel does nothing, and only \"Confirm send\" creates the announcement and sends. You can also press \"Send email\" on an already published announcement; the list shows whether each announcement was emailed and to how many, and the dialog warns you about duplicates."
    }
  ],
  "afterward": [
    "The announcement shows on the public competition page and the participants' Competition info page",
    "Each send leaves a summary in the audit log (successes and failures, no email addresses)",
    "A sent email cannot be recalled, and editing or deleting the announcement later does not update emails already sent"
  ],
  "nextSteps": "To remind specific students to update their registration, see \"Registrations that need an update, and reminder emails\".",
  "faq": [
    {
      "q": "Students did not receive an email after I published?",
      "a": "By default an announcement appears only on the website; to email it you must tick \"Also send an email notification\" or press \"Send email\" afterward. If it was sent but not received, check the recipient filters and expected count, the spam folder, and the failure count for that send in the audit log."
    },
    {
      "q": "Can announcement emails use formatting or attachments?",
      "a": "No. The body is always treated as plain text, with no formatting or attachments; the footer states it is an official competition notice and shows the organizer contact email."
    },
    {
      "q": "What if I have more than 300 recipients?",
      "a": "Narrow the filters by category, round or registration field and send in batches."
    },
    {
      "q": "Can I recall an email I sent by mistake?",
      "a": "No. Send a test email first, then send to a small group, and widen only after checking."
    }
  ]
}
